module.exports = __webpack_public_path__ + "img/prone_bridge.113d98fa.jpg";